import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HospitalesComponent } from './entidades-emergencias/hospitales/listado-hospitales/listado-hospitales.component';
import { PersonalesSaludComponent } from './entidades-emergencias/personales-salud/listado-personales-salud/listado-personales-salud.component';
import { DetallesEmergenciaComponent } from './emergencias/detalles-emergencias/detalles-emergencias.component';
import { ListadosEmergenciasMedicasComponent } from './emergencias/listados-emergencias-medicas/listados-emergencias-medicas.component';
import { MapaEmergenciasMedicasComponent } from './mapas/emergencias-medicas/mapa-emergencias-medicas.component';
import { DetallesHospitalComponent } from './entidades-emergencias/hospitales/detalles-hospital/detalles-hospital.component';
import { DetallesPersonalSaludComponent } from './entidades-emergencias/personales-salud/detalles-personales-salud/detalles-personales-salud.component';
import { DestinatarioAsistenciaComponent } from './entidades-emergencias/destinatario-asistencia/listado-destinatario-asistencia/listado-destinatario-asistencia.component';
import { DetallesDestinatarioAsistenciaComponent } from './entidades-emergencias/destinatario-asistencia/detalles-destinatario-asistencia/detalles-destinatario-asistencia.component';
import { TableroEmergenciasMedicasComponent } from './entidades-emergencias/tablero-emergencias-medicas/tablero-emergencias-medicas.component';
import { CentroAtencionComponent } from './entidades-emergencias/centros-atencion/listado-centros-atencion/listado-centros-atencion.component';
import { DetallesCentroAtencionComponent } from './entidades-emergencias/centros-atencion/detalles-centro-atencion/detalles-centro-atencion.component';
import { SolicitantesComponent } from './entidades-emergencias/solicitantes/solicitantes.component';
import { ListadoCategoriasMedicasComponent } from './entidades-emergencias/categorias-medicas/listado-categorias-medicas.component';
const routes: Routes = [
  { path: '', redirectTo: 'emergenciasMedicas', pathMatch: 'full' },

  //PRINCIPAL
  //Emergencias Médicas
  {
    path: 'emergenciasMedicas',
    title: 'Emergencias médicas',
    component: ListadosEmergenciasMedicasComponent,
    canActivate: [],
  },
  {
    path: 'emergenciasMedicas/detalles/:id',
    title: 'Emergencia médica',
    component: DetallesEmergenciaComponent,
    canActivate: [],
  },

  //TABLEROS
  {
    path: 'tableroMedico',
    title: 'Dashboard de emergencias médicas',
    component: TableroEmergenciasMedicasComponent,
    canActivate: [],
  },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////
  //#### ENTIDADES EMERGENCIAS MÉDICAS

  //Pacientes (destinatarios de asistencia). El `:tipoEmergencia` se conserva
  //por compatibilidad de links (siempre `medica`).
  {
    path: 'destinatariosAsistencia/detalles/:id',
    title: 'Paciente',
    component: DetallesDestinatarioAsistenciaComponent,
    canActivate: [],
  },
  {
    path: 'destinatariosAsistencia/:tipoEmergencia',
    title: 'Pacientes',
    component: DestinatarioAsistenciaComponent,
    canActivate: [],
  },
  {
    path: 'destinatariosAsistencia/:tipoEmergencia/detalles/:id',
    title: 'Paciente',
    component: DetallesDestinatarioAsistenciaComponent,
    canActivate: [],
  },

  //Bases de operaciones (centros de atención). El `:tipoEmergencia` se
  //conserva por compatibilidad de links (siempre `medica`).
  {
    path: 'centrosAtencion/:tipoEmergencia',
    title: 'Bases de operaciones',
    component: CentroAtencionComponent,
    canActivate: [],
  },
  {
    path: 'centrosAtencion/:tipoEmergencia/detalles/:id',
    title: 'Base de operaciones',
    component: DetallesCentroAtencionComponent,
    canActivate: [],
  },

  //Hospitales
  {
    path: 'hospitales',
    title: 'Hospitales',
    component: HospitalesComponent,
    canActivate: [],
  },
  {
    path: 'hospitales/detalles/:id',
    title: 'Hospital',
    component: DetallesHospitalComponent,
    canActivate: [],
  },

  //Personal de Salud
  {
    path: 'personalesSalud',
    title: 'Personal de salud',
    component: PersonalesSaludComponent,
    canActivate: [],
  },
  {
    path: 'personalesSalud/detalles/:id',
    title: 'Personal de salud',
    component: DetallesPersonalSaludComponent,
    canActivate: [],
  },

  //Solicitantes
  {
    path: 'solicitantes',
    title: 'Solicitantes',
    component: SolicitantesComponent,
    canActivate: [],
  },

  // Categorías médicas (Síntomas y Diagnósticos)
  {
    path: 'categoriasMedicas',
    title: 'Síntomas y diagnósticos',
    component: ListadoCategoriasMedicasComponent,
    canActivate: [],
  },

  ///////////////////////////////////////////////////////////////////////////////////////////////
  //#### MAPAS
  //Mapa emergencias medicas
  {
    path: 'mapaEmergenciasMedicas',
    title: 'Mapa de emergencias médicas',
    component: MapaEmergenciasMedicasComponent,
    canActivate: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EmergenciasRoutingModule {}
